import styled from 'styled-components';
import { Paper } from '@cashfree-intl/coherent';

export const StyledBanner = styled.div`
  margin-bottom: 1.75rem;
`;

export const StyledImportUnsettledAmountPaper = styled(Paper)`
  width: fit-content;
`;
